<template>
  <mobialisCard>
    <!--Fix Headers of titles, rn they are just for show -->
    <template v-if="hasMatchingInsuranceCompany">
      <h2>{{ $t('message.insurance.nextSteps.title') }}</h2>
      <p class="my-3">{{ $t('message.insurance.nextSteps.nextText') }}</p>
      <MobialisHorizontalRule></MobialisHorizontalRule>
    </template>
    <h4 class="mb-0">
      {{ $t('message.insurance.nextSteps.scoreQuestion') }}
      <br class="d-block d-sm-none" />
      {{ $t('message.trade.nextSteps.financeQuestion') }}
    </h4>
    <p class="my-3">{{ $t('message.insurance.nextSteps.fretQuestion') }}</p>
    <MobialisBankStrip class="mb-4" :company-list="getBankStrips" logoSpacing="3"> </MobialisBankStrip>
    <MobialisButton data-cy="navigateToCredit" @click="navigateToCreditApp">{{
      $t('message.insurance.nextSteps.checkScore')
    }}</MobialisButton>
  </mobialisCard>
</template>
<script>
import { mapGetters } from 'vuex';
import MobialisBankStrip from '../BankStrip.vue';

export default {
  name: 'NextStep',
  data() {
    return {};
  },
  components: {
    MobialisBankStrip,
  },
  props: {
    hasMatchingInsuranceCompany: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    navigateToCreditApp() {
      this.$router.push({ path: this.getProductHomeRoute('credit') });
    },
  },
  computed: {
    ...mapGetters('business', ['getBankStrips']),
    ...mapGetters(['getProductHomeRoute']),
  },
};
</script>
<style lang="scss" scoped>
h2 {
  font-size: 22px;
  font-weight: bold;
}
h4 {
  font-size: 18px;
  font-weight: bold;
}
p {
  font-weight: normal;
  font-size: 16px;
  color: #4b5863;
}
</style>
